
export enum ManifestReportTypeCd {
	DELIVERED_MANIFEST = 'DeliveredManifest',
	EXCEPTIONS_MANIFEST = 'ExceptionsManifest',
	GUARANTEED_MANIFEST = 'GuaranteedManifest',
	NEW_SHIPMENT_MANIFEST = 'NewShipmentManifest',
	OUT_FOR_DELIVERY_MANIFEST = 'OutForDeliveryManifest',
	REGULAR_MANIFEST = 'RegularManifest'}

